// Vehicle identity stays in unit_id. Never infer selling units from that legacy
// field: old Legiun drafts use it for equipment, while main POS uses it for PCS.
export const getSellingUnitPayload = (item) => {
  if (item.item_type === 'SERVICE' || item.service_id || !item.selling_unit_id) return {};
  return { selling_unit_id: item.selling_unit_id };
};

export const getSellingUnitKey = (item) => item.selling_unit_id || '';
